const cards = [
  {
    title: '星辰变',
    author: '我吃西红柿',
    tags: ['奇幻', '热血'],
    desc: '一部讲述少年秦羽逆天改命的奇幻热血全本漫画，宏大的世界观构建与细腻的情感刻画，全集免费完整版下拉式阅读体验。',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20style%20book%20cover%20illustration%20with%20star-filled%20night%20sky%20and%20ancient%20sword%2C%20warm%20coral%20and%20deep%20indigo%20color%20scheme%2C%20fantasy%20adventure%20theme%2C%20dramatic%20lighting%2C%20motion%20effects%2C%20elegant%20artistic%20composition&width=600&height=800&seq=manga-card-01&orientation=portrait',
  },
  {
    title: '偷偷藏不住',
    author: '竹已',
    tags: ['恋爱', '校园'],
    desc: '暗恋成真的甜蜜恋爱全本漫画，从校服到婚纱的温暖故事，好看的韩漫风格细腻画风，下拉式沉浸阅读。',
    image: 'https://readdy.ai/api/search-image?query=Soft%20romantic%20manga%20style%20illustration%20with%20cherry%20blossoms%20and%20school%20uniform%20motif%2C%20warm%20pink%20and%20cream%20color%20palette%2C%20gentle%20lighting%2C%20dreamy%20atmosphere%2C%20love%20story%20theme%2C%20elegant%20composition&width=600&height=800&seq=manga-card-02&orientation=portrait',
  },
  {
    title: '诡秘之主',
    author: '爱潜水的乌贼',
    tags: ['悬疑', '奇幻'],
    desc: '穿越异世界的悬疑奇幻巨作漫画化，蒸汽朋克与克苏鲁元素的完美融合，全本漫画完整版一次看个够。',
    image: 'https://readdy.ai/api/search-image?query=Mysterious%20dark%20fantasy%20manga%20style%20illustration%20with%20Victorian%20era%20elements%20and%20foggy%20London%20streets%2C%20muted%20amber%20and%20deep%20shadow%20tones%2C%20steampunk%20aesthetic%2C%20dramatic%20noir%20lighting%2C%20intriguing%20atmosphere&width=600&height=800&seq=manga-card-03&orientation=portrait',
  },
  {
    title: '一人之下',
    author: '米二',
    tags: ['热血', '都市'],
    desc: '异人世界的精彩冒险，国漫巅峰之作，融合道家文化与现代都市的完美结合，全集漫画下拉式流畅阅读。',
    image: 'https://readdy.ai/api/search-image?query=Dynamic%20Chinese%20martial%20arts%20manga%20style%20illustration%20with%20modern%20city%20background%20and%20traditional%20elements%2C%20warm%20coral%20and%20gold%20color%20scheme%2C%20action%20oriented%20composition%2C%20energetic%20vibe%2C%20stylized%20movement%20lines&width=600&height=800&seq=manga-card-04&orientation=portrait',
  },
  {
    title: '某天成为公主',
    author: 'Plutus',
    tags: ['古风', '恋爱'],
    desc: '穿越成为公主的浪漫古风全本漫画，精致华丽的韩漫画风，皇室内外的爱恨纠葛，好看的漫画不容错过。',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20royal%20palace%20manga%20style%20illustration%20with%20flowing%20dresses%20and%20ornate%20architecture%2C%20soft%20rose%20gold%20and%20cream%20color%20palette%2C%20romantic%20historical%20fantasy%20theme%2C%20gentle%20dreamy%20lighting%2C%20refined%20artistic%20composition&width=600&height=800&seq=manga-card-05&orientation=portrait',
  },
  {
    title: '全球诡异时代',
    author: '黑山老鬼',
    tags: ['惊悚', '悬疑'],
    desc: '诡异降临全球，人类文明面临巨大挑战，惊悚悬疑类全本漫画神作，完整版下拉式阅读，剧情层层递进扣人心弦。',
    image: 'https://readdy.ai/api/search-image?query=Apocalyptic%20horror%20manga%20style%20illustration%20with%20dark%20stormy%20skies%20and%20abandoned%20cityscape%2C%20deep%20crimson%20and%20charcoal%20color%20scheme%2C%20eerie%20atmospheric%20lighting%2C%20suspenseful%20tone%2C%20dramatic%20composition%2C%20survival%20theme&width=600&height=800&seq=manga-card-06&orientation=portrait',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100 scroll-mt-16">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 text-center mb-4">
          精选热门漫画
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-xl mx-auto">
          精选全网最热全本漫画，韩漫日漫国漫一应俱全，免费完整版下拉式阅读
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {cards.map((card) => (
            <a
              key={card.title}
              href="#cards"
              onClick={(e) => e.preventDefault()}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="aspect-[3/4] overflow-hidden">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-2 mb-2 flex-wrap">
                  {card.tags.map((tag) => (
                    <span key={tag} className="px-2 py-0.5 text-xs bg-primary-100 text-primary-700 rounded-full whitespace-nowrap">
                      {tag}
                    </span>
                  ))}
                </div>
                <h3 className="font-heading text-lg text-foreground-900 mb-1">{card.title}</h3>
                <p className="text-xs text-foreground-500 mb-3">作者：{card.author}</p>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-3">{card.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}